// Подключение Jquery
import $ from '../../../libs/js/jquery.min';

window.jQuery = $;
window.$ = $;


window.mobileWidth = 1279;
window.mobileWidthSmall = 768;